export default __webpack_public_path__ + "static/media/job_offer11_m.fe285e3e.jpg";